import React from 'react';
import AverageDaysToInvoiceReport from './AverageDaysToInvoiceReport';
import InvoicingActivityReport from './InvoicingActivityReport';

/** Keep the existing Average Days route/permission key for bookmarks and grants. */
export default function InvoicingReports() {
  return <div className="p-4 space-y-6 text-label">
    <h1 className="text-2xl font-semibold">Invoicing Reports</h1>
    <section aria-label="Average Days to Invoice"><AverageDaysToInvoiceReport embedded /></section>
    <section aria-label="Invoicing Activity" className="border-t border-theme-border-primary pt-6"><InvoicingActivityReport embedded /></section>
  </div>;
}
